import _ from 'lodash';

export default function(obj) {
    let result = {};
    let keys = _.keys(obj);
    for (let i = 0, length = keys.length; i < length; i++) {
        result[obj[keys[i]]] = keys[i];
    }
    return result;
}